import React from 'react';
import IconLogo from '../../images/svg/logo.svg';
import Link from '../primitives/link';

const Logo = ({ to }) => (
    <Link css={{"display":"inline-block","width":"100%"}} to={to}>
        <IconLogo />
    </Link>
);

export default Logo;
